/** A starting code for a zone typed by name: upper-case words joined by hyphens, within the 32 characters a code may have. */
export function toZoneCode(name: string): string {
  return name
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 32);
}
